import styles from '../styles/configuration.module.scss';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import Rocket from '../svgs/rocket.svg';
import ConfigurationsFooter from '../components/configurationsFooter';
import Image from 'next/image';

export default function ThirdStep({ className, response }) {
    const { t } = useTranslation('configuration');

    return <div className={className || styles.third}>
        <div className={styles.content}>
            <Image src={Rocket} alt="" />
            {/* <Rocket /> */}
            { response ? <>
                <h2>{t('thankYou')}</h2>
                <p  dangerouslySetInnerHTML={{__html: t('sent', { interpolation: { escapeValue: false }})}} />
            </> : <h2 style={{ margin: '1rem 0' }}>{t('wrong')}</h2>
            }
            <Link href='/'>
                <button className='btn cloud'>{t('toHome')}</button>
            </Link>
        </div>
        <ConfigurationsFooter />
    </div>
};
